module.exports = __webpack_public_path__ + "img/logo.b811fa5a.png";